module.exports = __webpack_public_path__ + "img/certificates-hero.9045e60b.jpg";